import oficialia from "./oficialia/oficialia";

const temiscivil = {
  Oficialia: oficialia
}

export default temiscivil



//////////////////
// WEBPACK FOOTER
// ./static/js/api/temiscivil/sistema/temiscivil.js
// module id = null
// module chunks = 